import { useMemo } from "react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { FeedbackOverlayModel } from "../FeedbackOverlay"
import { FeedbackOverlayViewModel } from "../FeedbackOverlayView"

export function useFeedbackOverlayViewModel({
  feedbackType,
  defaultFormData,
  sendFeedback,
  onCancel
}: FeedbackOverlayModel): FeedbackOverlayViewModel {
  const { t } = useTranslation()
  const methods = useForm({
    defaultValues: defaultFormData
  })

  const headline = useMemo(
    () =>
      t("Feedback.FeedbackForPage", {
        feedbackType: t(`Feedback.${feedbackType}`) || t("Feedback.Feedback")
      }),
    [t, feedbackType]
  )

  const handleSubmit = useMemo(() => {
    return methods.handleSubmit(sendFeedback)
  }, [methods.handleSubmit, sendFeedback])

  return {
    headline,
    methods,
    onSubmit: handleSubmit,
    onCancel
  }
}
